


import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
    computed: {
        ...mapGetters([
            "sectionFormOpen",
            "countries",
            "config",
            "formData"
        ])
    }
})
export default class PhoneNumberEditComponent extends Vue {
    @Prop() type!: string;
    @Prop() total!: number;
}
